import { render, staticRenderFns } from "./OrderIndexView.vue?vue&type=template&id=28bcce18&scoped=true"
import script from "./OrderIndexView.vue?vue&type=script&lang=js"
export * from "./OrderIndexView.vue?vue&type=script&lang=js"
import style0 from "./OrderIndexView.vue?vue&type=style&index=0&id=28bcce18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bcce18",
  null
  
)

export default component.exports